<template>
  <select class="bg-white rounded-sm p-2 border-2 border-black-500 ml-2 mr-2" @change="select">
    <option v-if="!lang" disabled selected>Select your {{type}}</option>
    <option v-if="lang" disabled selected>{{lang}}</option>
    <option v-for="(item, index) in elements" :key="'index-' + index" :value="item.short">{{item.long}}</option>
  </select>
</template>

<script>
export default {
  name: 'Selector',
  props: {
    elements: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      required: false
    }
  },

  data () {
    return {
      defaultValue: null
    }
  },

  methods: {
    select (evt) {
      this.$emit('emitValue', evt.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Selector.vue